<div class="header flex items-center">
  <img class="case-image" [class.case-image--responsive]="responsiveImage()" [src]="caseItem().image" />
  <p class="modal-title flex items-center">
    {{ caseItem().name }}
  </p>
  @if (showPrice()) {
  <div class="case-price">
    <app-cost
      [cost]="caseItem().price"
      [balanceType]="balance()"
    ></app-cost>
  </div>
  }
</div>
<div class="divider horizontal w-full"></div>
<div class="skins">
  <app-skins-list
    [skins]="caseItem().skins"
    [selectable]="false"
    [balanceType]="balance()"
    [config]="{ mobile: { skin_min_width: '130px' } }"
  />
</div>
